module.exports = __webpack_public_path__ + "files/b7843aef5fae89c8b769a6910318affd.png";